<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <hr-constant-parameter-create-or-update ref="form" v-model="constant" :errors="errors" :editing="editing"></hr-constant-parameter-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :add-callback="createNew"
                    name="system-constant"
                    search
                    pagination="server"
                    :fields="fields"
                    :buttons="buttons"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import SystemConstantParametersApi from '@/api/system-constant-parameters'
import HRConstantParameterCreateOrUpdate from './components/HRConstantParameterCreateOrUpdate'

export default {
    components:{
        BCard,
        'hr-constant-parameter-create-or-update':HRConstantParameterCreateOrUpdate
    },
    data(){
        return{
            fields:[
                {name:"Veri Türü",key:"VisibleName",thClass:'w-30'},
                {name:"Değer",key:"Value",thClass:'w-30'},
                {name:"Geçerlilik Başlangıç Tarihi",key:"ValidityStartDateStr",thClass:'w-20'},
                {name:"Geçerlilik Bitiş Tarihi",key:"ValidityEndDateStr",thClass:'w-20'},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
            ],
            editing:false,
            errors:{},
            loading:false,
            constant:{
                Id:null,
                CompanySystemConstantDataTypeId:null,
                ValidityStartDate: null,
                ValidityEndDate: null,
                Value:null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.constant.Id = null
            this.constant.CompanySystemConstantDataTypeId = null
            this.constant.ValidityStartDate = null
            this.constant.ValidityEndDate = null
            this.constant.Value = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
            // editing=false prop'u çocuğa yansıdıktan sonra atanabilir tür listesini tazele.
            this.$nextTick(()=>{ if(this.$refs.form) this.$refs.form.refreshDataTypes() })
        },
        provider(data){
            return SystemConstantParametersApi.TableCategory({
                ...data,
                Code:'IK'
            })
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.constant.Id = item.Id
            this.constant.CompanySystemConstantDataTypeId = item.CompanySystemConstantDataTypeId
            this.constant.ValidityStartDate = item.ValidityStartDate
            this.constant.ValidityEndDate = item.ValidityEndDate
            this.constant.Value = item.Value
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            SystemConstantParametersApi.CreateOrUpdate(this.editing,this.constant).then(res=>{
                this.$result(res)
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('create-or-update')
                }
                this.loading = false
            }).catch(err => {
                this.$result(null,err)
                this.loading = false
            })
        }
    }
}
</script>

<style>

</style>